export enum CreatePresentationDialogPaneType {
    BLANK_PRESENTATION = "blank",
    GENERATE_WITH_AI = "generate-with-ai",
    TEAM_TEMPLATES = "team-templates",
    STARTER_TEMPLATES = "starter-templates",
    IMPORT_PPT = "import-ppt"
}
